import React from "react";
import { HeaderButton } from "../button/HeaderButton";
import { Repeat as ChangeExerciseIcon } from "lucide-react";
import { JourneyAnchors } from "../../constants";
import clsx from "clsx";
import { useMediaQuery } from "@mui/material";

export interface ChangeExerciseButtonProps {
  disabled?: boolean;
  className?: string;
  useThemePalette?: boolean;
  setExerciseListModalOpen: (value: boolean) => void;
}
export function ChangeExerciseButton(props: ChangeExerciseButtonProps) {
  const {
    disabled = false,
    className,
    useThemePalette = true,
    setExerciseListModalOpen,
  } = props;

  const isSmDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <HeaderButton
        startIcon={<ChangeExerciseIcon />}
        onClick={() => setExerciseListModalOpen(true)}
        disabled={disabled}
        className={clsx(className, JourneyAnchors.SELECT_EXERCISE_BUTTON)}
        useThemePalette={useThemePalette}
      >
        {isSmDown ? "Change" : "Change exercise"}
      </HeaderButton>
    </>
  );
}
